export const minBatchDetailTableColumnsWidth = {
  'customer.identify.doc_issue_country': 120,
  paymentAmount: 97,
  paymentCurrency: 77,
  paymentMethodType: 87,
};
